// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './story/'
import components from './components/'
import * as getData from './service/getData'
import * as mobile from './config/mUtils'

import './config/rem'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import {Popup} from 'vue-ydui/dist/lib.rem/popup'
import {Radio, RadioGroup} from 'vue-ydui/dist/lib.rem/radio'
import {ProgressBar} from 'vue-ydui/dist/lib.rem/progressbar'
import {Confirm, Alert, Toast, Notify, Loading} from 'vue-ydui/dist/lib.rem/dialog'
import {Slider, SliderItem} from 'vue-ydui/dist/lib.rem/slider'
import {CitySelect} from 'vue-ydui/dist/lib.rem/cityselect'
import 'vue-ydui/dist/ydui.base.css'
import 'vue-ydui/dist/ydui.rem.css'
import {DateTime} from 'vue-ydui/dist/lib.rem/datetime'

import {ActionSheet} from 'vue-ydui/dist/lib.rem/actionsheet'

Vue.component(ActionSheet.name, ActionSheet)
// 图片懒加载
import VueLazyload from 'vue-lazyload'

Object.keys(components).forEach((key) => {
  // 首字母大写
  var name = key.replace(/(\w)/, (v) => v.toUpperCase())
  Vue.component(`v${name}`, components[key])
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'http://park.hzqisheng.cn/404.png',
  loading: 'http://park.hzqisheng.cn/loading-spin.svg',
  attempt: 1
})
Vue.component(DateTime.name, DateTime)
Vue.use(VueAwesomeSwiper)
Vue.component(Popup.name, Popup)
Vue.component(Radio.name, Radio)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(ProgressBar.name, ProgressBar)
Vue.component(Slider.name, Slider)
Vue.component(SliderItem.name, SliderItem)
Vue.component(CitySelect.name, CitySelect)
Vue.prototype.$dialog = {
  confirm: Confirm,
  alert: Alert,
  toast: Toast,
  notify: Notify,
  loading: Loading
}

router.beforeEach((to, from, next) => {
  if (!from.name) {
    Vue.nextTick(() => {
      Vue.prototype.bridges.themeColor() // 设置APP头部主题色
      Vue.prototype.bridges.toggleClose(false) // 设置头部‘关闭’按钮显示与不显示
    })
  } else {
    Vue.prototype.bridges.toggleClose(true)
  }
  if (window.screen.height === 812 && window.screen.width === 375){
    store.state.h5phoneType = 1
  }
  if (mobile.getStore('myInfo')) {
    store.state.myInfo = JSON.parse(mobile.getStore('myInfo'))
  }
  if (to.query.parkToken) {
    store.state.platform = to.query.platform
    store.state.phoneType = to.query.phoneType
    store.state.userPhone = to.query.phone
    store.state.parkToken = to.query.parkToken
    store.state.channelId = to.query.channelId
    store.state.companyId = to.query.companyId
    store.state.companyName = to.query.companyName && to.query.companyName !== 'undefined' ? to.query.companyName : ''
    mobile.setStore('parkToken', store.state.parkToken)
    mobile.setStore('phoneType', store.state.phoneType)
    mobile.setStore('userPhone', store.state.userPhone)
    mobile.setStore('platform', store.state.platform)
    mobile.setStore('channelId', store.state.channelId)
    mobile.setStore('companyId', store.state.companyId)
    mobile.setStore('companyName', store.state.companyName)
    next()
  } else if (mobile.getCookie('userToken')) {
    store.state.channelId = mobile.getCookie('channelId')
    store.state.userPhone = mobile.getCookie('userMobile')
    store.state.parkToken = mobile.getCookie('userToken')
    mobile.setStore('channelId', store.state.channelId)
    mobile.setStore('parkToken', store.state.parkToken)
    mobile.setStore('userPhone', store.state.userPhone)
    next()
  } else {
    next();
  }
})

Vue.prototype.bridges = {
  /**
   * 使window滑到顶部
   */
  scrollToTop () {
    window.scrollTo(0, 0)
  },
  themeColor () {
    if (store.state.platform === 'iOS') {
      window.webkit.messageHandlers.themeColor.postMessage({
        color: '#D60000'
      })
      return
    }
    if (store.state.platform === 'Android') {
      window.test.themeColor('#D60000')
      return
    }
  },
  toggleClose (show) { // true:显示‘关闭’按钮
    if (store.state.platform === 'iOS') {
      window.webkit.messageHandlers.toggleClose.postMessage({
        show: show
      })
      return
    }
  }
}

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js